<div id="heading">
    <h1>Administration</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">About Us</a></li>
            <li class="breadcrumb-item active" aria-current="page">Administration</li>
        </ol>
    </nav>
</div>

<div id="administration" class="py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-4 mb-4" *ngFor="let admin of administration">
                <div class="card admin-card h-100 border-0 shadow-sm">
                    <div class="card-img-wrapper">
                        <img [src]="admin.img" [alt]="admin.name" class="card-img-top">
                    </div>
                    <div class="card-body text-center">
                        <h4 class="admin-name">{{admin.name}}</h4>
                        <div class="admin-divider mx-auto my-2"></div>
                        <p class="admin-position mb-0">{{admin.position}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>